import { styled, Box, BoxProps } from '@mui/material';


export const SubscriptionWrapper = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: 24,
}));

export const SingleHotlist = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  borderTop: '1px solid rgba(81,81,81,1)',
  borderBottom: '1px solid rgba(81,81,81,1)',
  padding: '12px 16px',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.background,
  ':not(:last-of-type)': {
    borderBottom: 'none',
  },
}));

export const ActionsWrapepr = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '15px',
}));

